<template>
<b-card>
   
    <validation-observer ref="simpleRules">
        <b-form>
            <!-- Section Informations -->
            <h4> {{$t('Device Information')}} </h4>
            <span class="font-weight-bold">{{$t('The fields with (*) are required')}}</span>
            <hr class="mb-2">
            <b-row>

                <!-- Field: Device Model-->
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('Device Model')+'*'"  label-for="device-model">
                        <validation-provider #default="{ errors }" name="device-model" rules="required">
                            <v-select :state="errors.length > 0 ? false:null" v-model="deviceData.deviceModelId" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="deviceOptions" :reduce="val => val.value" :clearable="false" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <!-- Field: Modem Identifier -->
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('Modem Identifier')+'*'"  label-for="modem-identifier">
                        <validation-provider #default="{ errors }" name="modem-identifier" rules="required">
                            <b-form-input id="modem-identifier" v-model="deviceData.modemIdentifier" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
              <b-col cols="12" md="4">

                <b-form-group :label="$t('Customer')" label-for="sim-card">
                  <vue-autosuggest v-model="searchQueryCustomer" :suggestions="filteredOptionsCustomer" :input-props="inputProps" @selected="selectHandlerCustomer" @input="onInputChangeCustomer">
                    <template slot-scope="{suggestion}">
                      <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
                    </template>
                  </vue-autosuggest>

                </b-form-group>
              </b-col>
            </b-row>
          <div class="my-2" v-show="deviceData.telemetries.length > 0">
            <h4  class="mt-2"> {{$t('Last Telemetries')}}</h4>
            <b-row>
              <b-table striped hover :items="deviceData.telemetries" :fields="tableColumns" responsive show-empty :empty-text="$t('No telemetry')">
                <!-- Column: managerEmail -->
                <template #head(position)>
                  {{ $t('Position')}}
                </template>
                <template #cell(position)="data">
                  <div class="font-weight-bold d-block text-nowrap">
                    <b-button :title="$t('Go to Google Maps')" size="sm" variant="info"
                              @click="toGoogleMap(data.item.lat, data.item.lng)"><feather-icon icon="MapPinIcon" size="16" /></b-button>
                  </div>
                </template>
              </b-table>
            </b-row>
          </div>

            <h4 class="mt-2"> {{$t('SIM Card Information')}}</h4>
            <hr class="mb-2">
            <b-row>
                <!-- Field: Mobile Operator-->
                <b-col cols="12" md="4">
                    <b-form-group :label="$t(' Mobile Operator')" label-for="mobile-operator">
                        <v-select v-model="deviceData.mobileOperatorId" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="operatorOptions" :reduce="val => val.value" :clearable="false" input-id="mobile-operator" />
                    </b-form-group>
                </b-col>

                <!-- Field: Mobile Provider -->
                <b-col cols="12" md="4">
                    <b-form-group :label="$t(' Mobile Provider')" label-for="mobile-provider">
                        <v-select v-model="deviceData.mobileOperatorProviderId" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="providerOptions" :reduce="val => val.value" :clearable="false" input-id="mobile-provider" />
                    </b-form-group>
                </b-col>

                <!-- Field: Sim Card Number -->
                <b-col cols="12" md="4">

                    <b-form-group :label="$t('SIM Card Number')" label-for="sim-card">
                        <vue-autosuggest v-model="searchQuery" :suggestions="filteredOptions" :input-props="inputProps" @selected="selectHandler" @input="onInputChange">
                            <template slot-scope="{suggestion}">
                                <span class="my-suggestion-item">{{ suggestion.item.number }}</span>
                            </template>
                        </vue-autosuggest>

                    </b-form-group>
                </b-col>

                <!-- Field: Notes -->
                <b-col cols="12" md="12">
                    <b-form-group :label="$t('Note')" label-for="note">
                        <b-form-textarea v-model="deviceData.note" id="note" rows="5" />
                    </b-form-group>
                </b-col>

                <!-- Btn: Save Submit -->
                <b-col v-if="!user.role.endsWith('VI')" cols="12">
                    <b-button variant="primary" type="submit" @click.prevent="validationForm">
                        {{$t('Save')}}
                    </b-button>
                </b-col>

            </b-row>
        </b-form>
    </validation-observer>
</b-card>
</template>

<script>
import {
  BTab,
  BTabs,
  BCard,
  BAlert,
  BLink, BTable
} from 'bootstrap-vue'
import {
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BCardText,
    BFormTextarea,
} from 'bootstrap-vue'
import {
    ref,
    onUnmounted
} from '@vue/composition-api'
import router from '@/router'
import store from '@/store'
import deviceStoreModule from '../deviceStoreModule'
import customerStoreModule from '../../customer/customerStoreModule'

import {
    VueAutosuggest
} from 'vue-autosuggest'

//import Cleave from 'vue-cleave-component'
import Cleave from 'cleave.js';
//import 'cleave.js/dist/addons/cleave-phone.br'

import vSelect from 'vue-select'

import {
    ValidationProvider,
    ValidationObserver
} from 'vee-validate'
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from '@validations'

export default {

    components: {
        BTab,
        BTabs,
        BCard,
        BAlert,
        BLink,

        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BCardText,
        BFormTextarea,
        BTable,

        VueAutosuggest,
        Cleave,
        vSelect

    },
    data() {
        return {
            myId: router.currentRoute.params.id,
            required,
            email,
            confirmed,
            url,
            between,
            alpha,
            integer,
            password,
            min,
            digits,
            alphaDash,
            length,

            filteredOptionsCustomer: [],
            datasuggestCustomer: [],
            datasuggest: [],
            filteredOptions: [],
            inputProps: {
                id: 'autosuggest__input',
                class: 'form-control',
                placeholder: this.$t('Search for Sim Cards ...'),
            },
            limit: 3,
            selected: null,

            myMask: {
                //prefix: '55',
                delimiters: ['-'],
                blocks: [1, 7],
                numericOnly: true
                //uppercase: true,
                //phone: true,
                //phoneRegionCode: 'BR',
            },
            
            tableColumns:[
              {key: 'dateTime', sortable: false, label:'Device DateTime'},
              {key: 'isOn', sortable: false, label:'IsOn'},
              {key: 'acc', sortable: false, label:'ACC'},
              {key: 'position', sortable: false, label:'Position'},
              {key: 'data', sortable: false, label:'Data'},
            ]

        }
    },

    methods: {
      toGoogleMap(lat, lng){
        const url = "https://www.google.com/maps?q=" + lat + "," + lng;
        window.open(url, '_blank');
      },

      validationForm() {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {

            if (this.deviceData.id === "") {
              this.deviceData.simCardNumber = this.searchQuery

              store.dispatch('app-device/addDevice', { deviceData: this.deviceData })
                  .then(response => {
                    const msg = (response && response.data && response.data.message)
                        ? response.data.message
                        : 'Successful device registration';

                    this.msgDialog(msg, 'success')
                    router.push({ name: 'list-device' })
                  })
                  .catch(error => {
                    const errMsg = (error.response && error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : 'FAILURE to register device';

                    this.msgDialog(errMsg, 'error')
                  })
            }
            else {
              this.deviceData.simCardNumber = this.searchQuery

              store.dispatch('app-device/updateDevice', { deviceData: this.deviceData })
                  .then(response => {
                    const msg = (response && response.data && response.data.message)
                        ? response.data.message
                        : 'Successful device update';

                    this.msgDialog(msg, 'success')
                  })
                  .catch(error => {
                    const errMsg = (error.response && error.response.data && error.response.data.message)
                        ? error.response.data.message
                        : 'FAILURE to update device';

                    this.msgDialog(errMsg, 'error')
                  })
            }
          }
        })
      },

        clearForm() {
            this.deviceData = {
                id: '',
                modemIdentifier: "",
                deviceModelId: "",
                mobileOperatorId: null,
                mobileOperatorProviderId: null,
                simCardNumber: "",
                customerId: "",
                note: "",

            }
        },

        msgDialog(msg, icon) {
            this.$swal({
                position: 'top-end',
                icon: icon,
                title: msg,
                showConfirmButton: false,
                timer: 1500 * 2,
                customClass: {
                    confirmButton: 'btn btn-primary',
                },

                buttonsStyling: false,
            })
        },

        selectHandler(option) {
            this.selected = option.item
            this.filteredOptions = []
            this.searchQuery = option.item.number
            this.deviceData.simCardNumber = option.item.number

        },
        selectHandlerCustomer(option) {
          this.selected = option.item
          this.filteredOptionsCustomer = []
          this.searchQueryCustomer = option.item.name
          this.deviceData.customerId = option.item.id
          
  
        },

        onInputChangeCustomer(text) {
            if (text === '' || text === undefined || text.length < 3) {

                return
            }

            store.dispatch('app-customer/fetchAllCustomers', {
                    q: this.searchQueryCustomer,
                    page:1,
                    perPage: 5

                })
                .then(response => {

                    this.filteredOptionsCustomer = [{
                        data: response.data.data,
                    }]

                })
                .catch(() => {})
        },
      onInputChange(text) {
        if (text === '' || text === undefined || text.length < 3) {

          return
        }

        store.dispatch('app-device/fetchSimCard', {
          q: this.searchQuery,

        })
            .then(response => {

              this.filteredOptions = [{
                data: response.data.data,
              }]

            })
            .catch(() => {})
      },
        suggestionSelected() {
        }
    },
    setup() {
        const deviceData = ref({
            id: '',
            modemIdentifier: "",
            deviceModelId: "",
            mobileOperatorId: null,
            mobileOperatorProviderId: null,
            simCardNumber: "",
            customerId: "",
            note: "",
        })
        const searchQuery = ref(``)
        const searchQueryCustomer = ref('')

        const providerOptions = ref([])
        const operatorOptions = ref([])
        const deviceOptions = ref([])

      const DEVICE_APP_STORE_MODULE_NAME = 'app-device'
      const CUSTOMER_APP_STORE_MODULE_NAME = 'app-customer'

        // Register module
      if (!store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) store.registerModule(DEVICE_APP_STORE_MODULE_NAME, deviceStoreModule)
      if (!store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) store.registerModule(CUSTOMER_APP_STORE_MODULE_NAME, customerStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
          if (store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) store.unregisterModule(DEVICE_APP_STORE_MODULE_NAME)
          if (store.hasModule(CUSTOMER_APP_STORE_MODULE_NAME)) store.unregisterModule(CUSTOMER_APP_STORE_MODULE_NAME)
        })

      const user = localStorage.userData != undefined ? JSON.parse(localStorage.userData) : {}

        if (router.currentRoute.params.id != undefined) {

            store.dispatch('app-device/fetchDevice', {
                    id: router.currentRoute.params.id
                    //id: '099122db-1dad-4c62-819d-071e49f3298e'
                })
                .then(response => {
                    deviceData.value = response.data
                    searchQueryCustomer.value = response.data.customerName

                    deviceData.value.id = response.data.id
                    deviceData.value.modemIdentifier = response.data.modemIdentifier
                    deviceData.value.simCardNumber = response.data.simCardNumber
                    deviceData.value.deviceModelId = response.data.deviceModelId

                    deviceData.value.note = response.data.note

                    if (response.data.simCardNumber) {
                        searchQuery.value = response.data.simCardNumber

                        store
                            .dispatch('app-device/fetchProvider', {
                                number: response.data.simCardNumber,

                            })
                            .then(res => {
                                deviceData.value.mobileOperatorId = res.data.mobileOperatorId;
                                deviceData.value.mobileOperatorProviderId = res.data.mobileOperatorProviderId;
                                
                            })
                            .catch(() => {})

                    }

                })
                .catch(error => {
                    if (error.response.status === 404) {
                        deviceData.value = undefined
                    }
                })
        } else {
            deviceData.value = {

                id: '',
                customerName: '',
                modemIdentifier: "",
                deviceModelId: "",
                mobileOperatorId: null,
                mobileOperatorProviderId: null,
                simCardNumber: "",
                customerId: "",
                note: "",
                telemetries: []

            }
        }

        //Fetch Device Mobile Operators
        store.dispatch('app-device/fetchMobileOperators')
            .then(response => {
                response.data.data.map(function (v, key) {
                    operatorOptions.value.push({
                        label: v.name,
                        value: v.id
                    }, );
                });

            })
            .catch(() => {})

        //Fetch Device Mobile Providers
        store.dispatch('app-device/fetchMobileProviders')
            .then(response => {
                response.data.data.map(function (v, key) {
                    providerOptions.value.push({
                        label: v.name,
                        value: v.id
                    });
                });

            })
            .catch(() => {})

        //Fetch Device Models
        store.dispatch('app-device/fetchDeviceModel')
            .then(response => {
                response.data.data.map(function (v, key) {
                    deviceOptions.value.push({
                        label: v.name,
                        value: v.id
                    });
                });

            })
            .catch(() => {})

        return {
            deviceData,
            searchQuery,
            providerOptions,
            operatorOptions,
            deviceOptions,
            searchQueryCustomer,
          user
        }
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-autosuggest.scss';
</style>

<style>

</style>
